export class RuleFunctionError extends Error {}

export class EvaluationError extends Error {}
